import React from "react";

const Minus = props => (
  <svg viewBox="0 0 12 2" fill="none" {...props}>
    <path
      d="M11.75.25H.25A.246.246 0 000 .5v1c0 .156.094.25.25.25h11.5c.125 0 .25-.094.25-.25v-1a.269.269 0 00-.25-.25z"
      fill="currentColor"
    />
  </svg>
);

export default Minus;
